import axios from "axios";
import { BASE_URL, decrypt } from "./common";
import sessionHelper from "../helper/session.helper";
let baseURL = BASE_URL + "api";
const http = axios.create({
  baseURL,
});

// VAPT Fix W2: the API encrypts these fields in every user-area response so the
// wire payload carries no plain PII. This interceptor walks the response body
// and transparently decrypts them, so components see plain values exactly as
// they did before VAPT was applied. Decrypt failures fall back to the original
// string (see decrypt() in common.js) so endpoints that still send plain values
// continue to work unchanged.
const PII_FIELDS = new Set([
  "email_id",
  "phone_number_1",
  "phone_number_2",
  "mobile",
  "mobile_number",
]);

function decryptPIIFields(node) {
  if (node == null) return;
  if (Array.isArray(node)) {
    for (let i = 0; i < node.length; i++) decryptPIIFields(node[i]);
    return;
  }
  if (typeof node !== "object") return;
  for (const key of Object.keys(node)) {
    const val = node[key];
    if (val && typeof val === "object") {
      decryptPIIFields(val);
    } else if (typeof val === "string" && PII_FIELDS.has(key)) {
      node[key] = decrypt(val);
    }
  }
}

http.interceptors.request.use(
  (config) => {
    let token = localStorage.token;
    if (token) {
      config.headers.common["Authorization"] = "bearer " + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
http.interceptors.response.use(
  (response) => {
    // VAPT Fix W1 retest: backend no longer returns JwtToken in body; it now
    // sends the JWT via the X-Auth-Token response header (exposed by CORS).
    // Capture and save so the Authorization header on later requests still works.
    try {
      const hdr = response.headers && (response.headers["x-auth-token"] || response.headers["X-Auth-Token"]);
      if (hdr) localStorage.token = hdr;
    } catch (e) { /* ignore */ }
    try {
      decryptPIIFields(response.data);
    } catch (e) { /* never let decrypt break a response */ }
    return response;
  },
  (error) => {
    if (error.response && error.response.status == 401) {
      error.message = 'Authorization has been denied for this request.';
      // VAPT Fix W6: clear sessionStorage session + localStorage token
      sessionHelper.clearSession();
      localStorage.removeItem("token");
      setTimeout(() => {
        location.reload();
      }, 1000);
    }
    return Promise.reject(error);
  }
);
export default http;
